export function ConveyancingFees() {
  return (
    <div className="mx-auto max-w-3xl px-4 py-12 sm:px-6">
      <h1 className="mb-8 text-3xl font-bold tracking-tight">
        Buyers and Conveyancing Fees
      </h1>

      <section className="space-y-6 text-gray-700 dark:text-gray-300 [&_h2]:mb-2 [&_h2]:mt-8 [&_h2]:text-xl [&_h2]:font-semibold [&_h3]:mb-1 [&_h3]:mt-4 [&_h3]:text-base [&_h3]:font-semibold">
        <p>
          When buying a property, there are typically two types of conveyancing
          fees:
        </p>

        <h2>1. Bond Registration Fees</h2>
        <p>
          If you finance your purchase through a bank, you will be responsible
          for bond registration fees. These fees are charged by the conveyancer
          appointed by the bank to register the mortgage bond over the property,
          as security for the loan. These fees are calculated on the value of
          the mortgage bond being registered.
        </p>

        <h2>2. Transfer Fees</h2>
        <p>
          Transfer fees are the conveyancing fees associated with transferring
          ownership of the property from the seller to the buyer. These fees are
          payable by the buyer and apply whether the purchase is financed or
          not. These fees are calculated on the selling price of the property.
          Any deposit paid does not affect the selling price.
        </p>

        <h2>Who Appoints the Transfer Conveyancer?</h2>
        <p>
          Although buyers are usually responsible for paying the transfer fees,
          most standard Offers to Purchase give the seller the right to appoint
          the transferring conveyancer.
        </p>

        <h2>The Role of the Transferring Conveyancer</h2>
        <p>
          A common misconception is that the transferring conveyancer acts for
          the person who appointed them. This is not the case.
        </p>
        <p>
          The transferring conveyancer is required to act objectively, in
          accordance with the law and the terms of the sale agreement agreed
          between the buyer and seller. Their role is to manage the transfer
          process and give effect to the rights and obligations of both parties.
        </p>

        <h2>Why BidConvey?</h2>
        <p>
          Because buyers are typically excluded from the appointment process,
          they are often given no choice in the selection of the transferring
          conveyancer.
        </p>
        <p>
          BidConvey promotes buyer inclusion by allowing buyers to participate
          in the appointment process, creating greater choice, transparency, and
          confidence in the selection of a transferring conveyancer.
        </p>
      </section>
    </div>
  );
}
